import React from "react";
import { Navigate } from "react-router-dom";
import PermissionDenied from "../page/PermissionDenied/index.jsx";
import jwtDecode from "jwt-decode";

export const PrivateRoute = ({ component: RouteComponent, path, roles }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" />;
  }

  const user = jwtDecode(token);
  const dateToday = new Date();
  const expire = new Date(user.exp * 1000);

  if (expire <= dateToday) {
    console.log("user exp : ", expire, " timenow, ", dateToday);
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }

  const isAuthenticated = token !== null;
  const userHasRequiredRole =
    user && roles.includes(user.user.role) ? true : false;

  if (isAuthenticated && userHasRequiredRole) {
    return <RouteComponent />;
  }

  if (isAuthenticated && !userHasRequiredRole) {
    return <PermissionDenied />;
  }

  return <Navigate to="/login" />;
};
